module.exports = __webpack_public_path__ + "img/serve7.57d500b4.png";